















































import { Field } from '@/components/Visuals/index'
import { Component, Prop, Vue } from 'vue-property-decorator'

@Component
export default class HelloWorld extends Vue {
  @Prop() public api!: Function

  @Prop() public paginate?: boolean

  @Prop() public include?: string

  @Prop() public screening?: Record<string, any>

  @Prop() public fields!: Array<Field>

  items: Array<Record<string, any>> = []

  keyword = ''

  loading = true

  filters: Record<string, any> = {
    field: null,
    order: null
  }

  pagination: Record<string, any> = {
    // eslint-disable-next-line
    per_page: 20,
    // eslint-disable-next-line
    current_page: 1
  }

  async created () {
    await this.getItems(1)
  }

  async getItems (page: number) {
    this.loading = true

    // eslint-disable-next-line
    this.pagination.current_page = page

    const params: Record<string, any> = {}

    if (this.paginate) {
      // eslint-disable-next-line
      params.page = this.pagination.current_page
      // eslint-disable-next-line
      params.per_page = this.pagination.per_page
    }

    params.keyword = this.keyword
    params.include = this.include || undefined

    try {
      const { data } = await this.api({
        ...params,
        ...this.filters,
        ...this.screening
      })

      if (this.paginate) {
        this.items = data.data
        this.pagination = data.meta.pagination
      } else {
        this.items = data
      }
      this.loading = false
    } finally {
      this.loading = false
    }
  }

  async onSortChange (field: Record<string, any>) {
    this.filters.field = field.prop
    this.filters.order = field.order
    await this.getItems(1)
  }

  async filterHandler (value: Record<string, any>) {
    const key = Object.keys(value)[0]
    this.filters[key] = value[key][0]
    await this.getItems(1)
  }
}
